import { Browser } from "@capacitor/browser";
import {
  IonAccordion,
  IonAccordionGroup,
  IonBackdrop,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemSliding,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import axios from "axios";
import { call, chevronForwardOutline, helpCircle, mail } from "ionicons/icons";
import React, { useState } from "react";
import { RouteProps } from "react-router-dom";
import { EXTERNAL_LINKS, CME_GROUP_POSTER_URL } from "./Constants";
import {
  CapacitorPreferencesConstants,
  EndpointsConstants,
} from "../components/Constants";
import LogoutButton from "../components/helpers/LogoutButton";
import { getCapacitorPreference } from "../utils/core-utils/capPreferencesUtils";
import { BE_URL } from "../utils/urlUtils";
import { getOrCreateStickySessionId } from "../utils/stickySessionIdManager";

interface TermsAndConditionsBackdropProps extends RouteProps {
  setIsUserTermsConditionAccepted: any;
  onLogin: any;
}
const TermsAndConditionsBackdrop: React.FC<TermsAndConditionsBackdropProps> = ({
  setIsUserTermsConditionAccepted,
  onLogin,
}) => {
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [isTermsofUseAccepted, setIsTermsofUseAccepted] = useState(false);
  const [isDisclaimerPolicyAccepted, setIsDiscalimerPolicyAccepted] =
    useState(false);
  const [isPrivacyPolicyAccepted, setIsPrivacyPolicyAccepted] = useState(false);

  const handleAcceptTermsCondition = async () => {
    const stickySessionId = await getOrCreateStickySessionId();
    const myHeaders = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    const myParams = {
      "x-sticky-session-id": stickySessionId,
    };
    const token = await getCapacitorPreference(
      CapacitorPreferencesConstants.ACCESS_TOKEN,
    );
    const data = new URLSearchParams();
    data.append("userAgreement", "true");
    data.append("disclaimerPolicy", "true");
    data.append("privacyPolicy", "true");
    data.append("accessToken", `${token}`);

    axios
      .post(BE_URL + EndpointsConstants.SAVE_TERMS_ENDPOINT, data, {
        headers: myHeaders,
        params: myParams,
      })
      .then((response: any) => {
        setIsUserTermsConditionAccepted(response.data);
        onLogin();
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };

  const openCapacitorSite = async (link: any) => {
    await Browser.open({ url: link });
  };

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle></IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonBackdrop visible={true}></IonBackdrop>
        <div id="t_and_c_parent">
          <IonCard>
            <img
              alt="CME Group Poster"
              src={CME_GROUP_POSTER_URL}
              height={100}
              width="100%"
              style={{ objectFit: "cover" }}
            />
            <IonCardHeader>
              <IonCardTitle>CME Direct</IonCardTitle>
              <IonCardSubtitle>Accept Terms & Conditions</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              Before using your CME Group Login to sign in, you must read and
              agree to the following, checking each box to indicate that you
              have done so:
            </IonCardContent>
            <IonList inset={true}>
              {EXTERNAL_LINKS.map(({ title, link }) => (
                <IonItemSliding key={link}>
                  <IonItem button={false} detail={false}>
                    <IonCheckbox
                      slot="start"
                      // labelPlacement="end"
                      value={title}
                      onIonChange={(event: any) => {
                        event.detail.value === "Terms of Use"
                          ? setIsTermsofUseAccepted(event.detail.checked)
                          : event.detail.value === "Disclaimer Policy"
                            ? setIsDiscalimerPolicyAccepted(
                                event.detail.checked,
                              )
                            : event.detail.value === "Privacy Policy" &&
                              setIsPrivacyPolicyAccepted(event.detail.checked);
                      }}
                    ></IonCheckbox>
                    <IonLabel
                      slot="end"
                      onClick={() => openCapacitorSite(link)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>{title}</span>
                      <IonIcon
                        icon={chevronForwardOutline}
                        size="small"
                        color="medium"
                      ></IonIcon>
                    </IonLabel>
                  </IonItem>
                </IonItemSliding>
              ))}
            </IonList>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <IonButton
                  fill="clear"
                  color="dark"
                  onClick={() => setIsHelpModalOpen(true)}
                >
                  <IonIcon slot="start" icon={helpCircle}></IonIcon>
                  Help
                </IonButton>
              </div>
            </div>
          </IonCard>
        </div>
        <IonModal isOpen={isHelpModalOpen}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Customer Center</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setIsHelpModalOpen(false)}>
                  Close
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonListHeader>Contact Us</IonListHeader>
            <IonAccordionGroup expand="inset" multiple={true}>
              <IonAccordion>
                <IonItem slot="header" color="light">
                  <IonIcon
                    aria-hidden="true"
                    icon={call}
                    slot="start"
                  ></IonIcon>
                  <IonLabel>Phone</IonLabel>
                </IonItem>
                <div slot="content">
                  <IonItem className="even_item_bg" lines="none">
                    <IonLabel>United States</IonLabel>
                    <IonLabel slot="end">+1 312 456 1560</IonLabel>
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Europe</IonLabel>
                    <IonLabel slot="end">+44 20 3379 3802</IonLabel>
                  </IonItem>
                  <IonItem className="even_item_bg" lines="none">
                    <IonLabel>Asia</IonLabel>
                    <IonLabel slot="end">+65 6593 5536</IonLabel>
                  </IonItem>
                </div>
              </IonAccordion>
              <IonAccordion>
                <IonItem slot="header" color="light" lines="none">
                  <IonIcon
                    aria-hidden="true"
                    icon={mail}
                    slot="start"
                  ></IonIcon>
                  <IonLabel>Email</IonLabel>
                </IonItem>
                <div slot="content">
                  <IonItem className="even_item_bg" lines="none">
                    <IonLabel>EASE.AtYourService@cmegroup.com</IonLabel>
                  </IonItem>
                </div>
              </IonAccordion>
            </IonAccordionGroup>
          </IonContent>
        </IonModal>
      </IonContent>
      <IonFooter className="ion-padding">
        <IonGrid>
          <IonRow>
            <IonCol>
              <LogoutButton />
            </IonCol>
            <IonCol>
              <IonButton
                color={"primary"}
                expand="block"
                onClick={handleAcceptTermsCondition}
                disabled={
                  !isTermsofUseAccepted ||
                  !isDisclaimerPolicyAccepted ||
                  !isPrivacyPolicyAccepted
                }
              >
                Submit
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};

export default TermsAndConditionsBackdrop;
